<template>
    <b-form-group
        :label="fieldLabel"
        label-for="sections"
        :labelClass="labelClass"
        :class="{ 'c-text-muted': disabled }"
    >
        <template slot="label">
            <slot name="label">
                <span>{{ fieldLabel }}</span>
            </slot>
        </template>
        <Multiselect
            id="sections"
            :state="state"
            :selected="value"
            :options="options"
            :multiple="multiple"
            :loading="isLoading"
            :disabled="disabled"
            :closeOnSelect="!multiple"
            :placeholder="placeholder"
            :groupLabel="groupLabelKey"
            :groupValues="groupValuesKey"
            :groupSelect="applyGroupSelection"
            aria-describedby="section-feedback"
            @click="getSectionsFromApi"
            @changeValue="$emit('update:value', $event)"
        />
        <b-form-invalid-feedback id="section-feedback">
            <slot />
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import i18n from '@/i18n'
import api from '@/services/api'
import mapperToOptions from './mapperSectionsToOptions'
import { Multiselect } from '@/views/components/selects'

export default {
    name: 'Sections',
    components: {
        Multiselect,
    },
    props: {
        label: String,
        state: Boolean,
        disabled: Boolean,
        multiple: Boolean,
        lazyLoading: Boolean,
        placeholder: String,
        enableGroupSelect: Boolean,
        labelClass: [Array, Object, String],
        value: {
            type: [Object, Array],
        },
        sectionsType: {
            type: Array,
            default: () => ['unit', 'department'],
        },
        enabledSectionType: {
            type: String,
            default: 'department',
        },
    },
    data() {
        return {
            sections: [],
            isLoading: false,
            sectionsAreAlreadyLoaded: false,
        }
    },
    computed: {
        fieldLabel() {
            if (this.label) {
                return this.label
            }

            return i18n.t(`groupLevel.${this.enabledSectionType}`)
        },
        applyGroupSelection() {
            return this.enableGroupSelect && this.multiple
        },
        groupValuesKey() {
            return this.applyGroupSelection ? 'items' : null
        },
        groupLabelKey() {
            return this.applyGroupSelection ? 'group' : null
        },
        options() {
            const items = mapperToOptions(
                this.sections,
                this.enabledSectionType
            )

            if (this.applyGroupSelection) {
                return [{ items, group: i18n.t('form.button.allOptions') }]
            }

            return items
        },
    },
    mounted() {
        if (!this.lazyLoading) {
            this.getSectionsFromApi()
        }
    },
    methods: {
        getSectionsFromApi() {
            if (this.sectionsAreAlreadyLoaded) {
                return
            }

            this.isLoading = true
            api.get('/sections', {
                params: {
                    artifact_type: 'objective',
                    operation: 'create',
                    with: 'descendants',
                    filter:
                        'id;type;name;_lft;_rgt;descendants.name;descendants._lft',
                    search: `type:${this.sectionsType.join()}`,
                    searchFields: 'type:in',
                },
            })
                .then(resp => {
                    this.sections = resp.data.data
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.isLoading = false
                    this.sectionsAreAlreadyLoaded = true
                })
        },
    },
}
</script>

<style>
.c-text-muted label {
    color: #73818f !important;
}
</style>
